export function fixMojibake() {
  if (typeof localStorage === 'undefined') return;

  const tables = [
    { key: 'inspect_clients', nameField: 'name', secondaryField: 'legalName' },
    { key: 'inspect_projects', nameField: 'name', secondaryField: 'description' },
    { key: 'inspect_project_unit_areas', nameField: 'name' },
    { key: 'inspect_equipments', nameField: 'tag', secondaryField: 'name' }
  ];

  // Regex para capturar qualquer caractere corrompido (ðŸ e variações) e espaços seguintes
  // Assim como capturar emojis reais que possam ter sido usados como ícones
  const fixRegex = /^(?:ðŸ\S*|[\uD800-\uDBFF][\uDC00-\uDFFF])\s*/;

  let totalFixed = 0;
  
  tables.forEach(table => {
    try {
      const dataStr = localStorage.getItem(table.key);
      if (!dataStr) return;
      
      const data = JSON.parse(dataStr);
      let changed = false;
      const changes: any[] = [];
      
      const fixedData = data.map((item: any) => {
         const isTuple = Array.isArray(item) && item.length === 2 && typeof item[0] === 'string';
         const obj = isTuple ? item[1] : item;
         let objChanged = false;

         const fields = [table.nameField];
         if (table.secondaryField) fields.push(table.secondaryField);

         fields.forEach(field => {
           if (obj && typeof obj[field] === 'string') {
             const original = obj[field];
             
             /**
              * Havia aqui uma tentativa de montar uma regex com flag `v` e
              * `\p{Emoji}`, sobre-escapada (`\\\\S` virava barra + S), que
              * por isso **nunca compilava**: o `catch` caía sempre no
              * `fixRegex`. Não quebrava nada — mas era ramo morto, e
              * "consertá-lo" faria a limpeza passar a remover emoji comum
              * do começo de nomes de Cliente, Projeto e TAG, que é
              * alteração de dado que ninguém pediu.
              *
              * O comportamento é o que sempre valeu: só o mojibake `ðŸ…` e
              * o par substituto são removidos.
              */
             const regexToUse = fixRegex;

             if (regexToUse.test(original)) {
               const fixed = original.replace(regexToUse, '');
               changes.push({
                 Tabela: table.key,
                 Campo: field,
                 'Valor Atual': original,
                 'Valor Correto': fixed
               });
               obj[field] = fixed;
               objChanged = true;
               changed = true;
             }
           }
         });
         
         if (objChanged) {
           totalFixed++;
         }
         return isTuple ? [item[0], obj] : obj;
      });

      if (changes.length > 0) {
        console.log(`%c[MOJIBAKE FIXER] Encontrados registros corrompidos em ${table.key}:`, "color: var(--status-warning-text); font-weight: bold; font-size: 14px;");
        console.table(changes);
        localStorage.setItem(table.key, JSON.stringify(fixedData));
        console.log(`%c[MOJIBAKE FIXER] ${table.key} corrigido com sucesso!`, "color: #10b981; font-weight: bold;");
      }
    } catch (e) {
      console.error(`Erro ao analisar ${table.key}:`, e);
    }
  });

  if (totalFixed > 0) {
    console.log(`%c[MOJIBAKE FIXER] Total de ${totalFixed} registros corrigidos. Foi feita a correção segura no banco (localStorage).`, "color: var(--status-info-text); font-weight: bold; font-size: 14px;");
    // Reload automatically to reflect changes
    setTimeout(() => {
        window.location.reload();
    }, 1500);
  } else {
    console.log(`%c[MOJIBAKE FIXER] O banco de dados foi verificado e não há caracteres corrompidos.`, "color: #10b981; font-weight: bold;");
  }
}
